// Données de démonstration pour le portail central (jamais vide en démo).
// Utilisées tant que les modules externes ne renvoient pas encore de données réelles.

export const DEMO_HEALTH = {
  fr: [
    { key: "pipeline", label: "Pipeline CRM", value: "48 500 $", icon: "TrendingUp", accent: "#dc143c", module: "crm" },
    { key: "receivable", label: "Factures à recevoir", value: "12 400 $", icon: "FileText", accent: "#EAB308", module: "compta" },
    { key: "hours", label: "Heures cette semaine", value: "386 h", icon: "Clock", accent: "#EAB308", module: "punch" },
    { key: "quotes", label: "Soumissions en attente", value: "7", icon: "FileSignature", accent: "#dc143c", module: "devis-ai" },
    { key: "projects", label: "Projets actifs", value: "4", icon: "Boxes", accent: "#EAB308", module: "erp" },
    { key: "tickets", label: "Tickets ouverts", value: "3", icon: "LifeBuoy", accent: "#dc143c", module: "support" },
    { key: "clients", label: "Clients actifs", value: "8", icon: "Users", accent: "#EAB308", module: "crm" },
    { key: "conversion", label: "Taux de conversion", value: "62 %", icon: "Target", accent: "#dc143c", module: "crm" },
  ],
  en: [
    { key: "pipeline", label: "CRM pipeline", value: "$48,500", icon: "TrendingUp", accent: "#dc143c", module: "crm" },
    { key: "receivable", label: "Receivables", value: "$12,400", icon: "FileText", accent: "#EAB308", module: "compta" },
    { key: "hours", label: "Hours this week", value: "386 h", icon: "Clock", accent: "#EAB308", module: "punch" },
    { key: "quotes", label: "Pending quotes", value: "7", icon: "FileSignature", accent: "#dc143c", module: "devis-ai" },
    { key: "projects", label: "Active projects", value: "4", icon: "Boxes", accent: "#EAB308", module: "erp" },
    { key: "tickets", label: "Open tickets", value: "3", icon: "LifeBuoy", accent: "#dc143c", module: "support" },
    { key: "clients", label: "Active clients", value: "8", icon: "Users", accent: "#EAB308", module: "crm" },
    { key: "conversion", label: "Conversion rate", value: "62%", icon: "Target", accent: "#dc143c", module: "crm" },
  ],
};

export const DEMO_ACTIONS = {
  fr: [
    { id: "a1", label: "3 feuilles de temps à approuver", module: "punch", moduleName: "PROGÈRE PUNCH", priority: "urgente", icon: "Clock" },
    { id: "a2", label: "2 soumissions à relancer", module: "devis-ai", moduleName: "PROGÈRE DEVIS AI", priority: "normale", icon: "FileSignature" },
    { id: "a3", label: "1 facture en retard", module: "compta", moduleName: "PROGÈRE COMPTA", priority: "urgente", icon: "FileText" },
    { id: "a4", label: "4 tâches chantier ouvertes", module: "erp", moduleName: "PROGÈRE ERP", priority: "normale", icon: "Boxes" },
    { id: "a5", label: "2 clients sans suivi depuis 7 jours", module: "crm", moduleName: "PROGÈRE CRM", priority: "faible", icon: "Users" },
  ],
  en: [
    { id: "a1", label: "3 timesheets to approve", module: "punch", moduleName: "PROGÈRE PUNCH", priority: "urgente", icon: "Clock" },
    { id: "a2", label: "2 quotes to follow up", module: "devis-ai", moduleName: "PROGÈRE DEVIS AI", priority: "normale", icon: "FileSignature" },
    { id: "a3", label: "1 overdue invoice", module: "compta", moduleName: "PROGÈRE COMPTA", priority: "urgente", icon: "FileText" },
    { id: "a4", label: "4 open job-site tasks", module: "erp", moduleName: "PROGÈRE ERP", priority: "normale", icon: "Boxes" },
    { id: "a5", label: "2 clients with no follow-up in 7 days", module: "crm", moduleName: "PROGÈRE CRM", priority: "faible", icon: "Users" },
  ],
};

export const DEMO_ACTIVITY = {
  fr: [
    { id: "e1", icon: "FileSignature", accent: "#EAB308", text: "Nouvelle soumission créée", module: "DEVIS AI", who: "Mathieu", when: "il y a 12 min" },
    { id: "e2", icon: "Clock", accent: "#EAB308", text: "Feuille de temps approuvée", module: "PUNCH", who: "Sophie", when: "il y a 40 min" },
    { id: "e3", icon: "Users", accent: "#dc143c", text: "Nouveau client ajouté", module: "CRM", who: "Julie", when: "il y a 2 h" },
    { id: "e4", icon: "FileText", accent: "#EAB308", text: "Facture #1042 créée", module: "COMPTA", who: "Marc", when: "il y a 3 h" },
    { id: "e5", icon: "Boxes", accent: "#EAB308", text: "Projet « Tour Nord » mis à jour", module: "ERP", who: "Mathieu", when: "hier" },
    { id: "e6", icon: "LifeBuoy", accent: "#dc143c", text: "Billet de support ouvert", module: "SUPPORT", who: "Sophie", when: "hier" },
  ],
  en: [
    { id: "e1", icon: "FileSignature", accent: "#EAB308", text: "New quote created", module: "DEVIS AI", who: "Mathieu", when: "12 min ago" },
    { id: "e2", icon: "Clock", accent: "#EAB308", text: "Timesheet approved", module: "PUNCH", who: "Sophie", when: "40 min ago" },
    { id: "e3", icon: "Users", accent: "#dc143c", text: "New client added", module: "CRM", who: "Julie", when: "2 h ago" },
    { id: "e4", icon: "FileText", accent: "#EAB308", text: "Invoice #1042 created", module: "COMPTA", who: "Marc", when: "3 h ago" },
    { id: "e5", icon: "Boxes", accent: "#EAB308", text: "Project \"North Tower\" updated", module: "ERP", who: "Mathieu", when: "yesterday" },
    { id: "e6", icon: "LifeBuoy", accent: "#dc143c", text: "Support ticket opened", module: "SUPPORT", who: "Sophie", when: "yesterday" },
  ],
};

export const SHORTCUTS = {
  fr: [
    { label: "Créer un client", icon: "UserPlus", module: "crm" },
    { label: "Créer une soumission", icon: "FileSignature", module: "devis-ai" },
    { label: "Ajouter un employé", icon: "Users", module: "punch" },
    { label: "Créer un projet", icon: "Boxes", module: "erp" },
    { label: "Créer une facture", icon: "FileText", module: "compta" },
    { label: "Ouvrir un ticket", icon: "LifeBuoy", route: "/support" },
    { label: "Inviter un utilisateur", icon: "UserPlus", route: "/app/team" },
    { label: "Gérer mon abonnement", icon: "CreditCard", route: "/tarification" },
  ],
  en: [
    { label: "Add a client", icon: "UserPlus", module: "crm" },
    { label: "Create a quote", icon: "FileSignature", module: "devis-ai" },
    { label: "Add an employee", icon: "Users", module: "punch" },
    { label: "Create a project", icon: "Boxes", module: "erp" },
    { label: "Create an invoice", icon: "FileText", module: "compta" },
    { label: "Open a ticket", icon: "LifeBuoy", route: "/support" },
    { label: "Invite a user", icon: "UserPlus", route: "/app/team" },
    { label: "Manage subscription", icon: "CreditCard", route: "/tarification" },
  ],
};

export const ECOSYSTEM_FLOWS = {
  fr: [
    "CRM → DEVIS AI → ERP → COMPTA",
    "PUNCH → COMPTA / PAIE",
    "DEVIS AI → TAKEOFF",
    "ERP → PUNCH",
    "CORE → tous les modules",
  ],
  en: [
    "CRM → DEVIS AI → ERP → COMPTA",
    "PUNCH → COMPTA / PAYROLL",
    "DEVIS AI → TAKEOFF",
    "ERP → PUNCH",
    "CORE → all modules",
  ],
};

export const SETUP_CHECKLIST = {
  fr: [
    { key: "logo", label: "Ajouter le logo de l'entreprise", done: true },
    { key: "users", label: "Ajouter les utilisateurs", done: true },
    { key: "modules", label: "Configurer les modules", done: true },
    { key: "client", label: "Ajouter un premier client", done: false },
    { key: "project", label: "Ajouter un premier projet", done: false },
    { key: "stripe", label: "Connecter Stripe", done: true },
    { key: "taxes", label: "Configurer les taxes (TPS/TVQ)", done: false },
    { key: "team", label: "Inviter l'équipe", done: false },
  ],
  en: [
    { key: "logo", label: "Add company logo", done: true },
    { key: "users", label: "Add users", done: true },
    { key: "modules", label: "Configure modules", done: true },
    { key: "client", label: "Add a first client", done: false },
    { key: "project", label: "Add a first project", done: false },
    { key: "stripe", label: "Connect Stripe", done: true },
    { key: "taxes", label: "Set up taxes (GST/QST)", done: false },
    { key: "team", label: "Invite the team", done: false },
  ],
};

export const ASSISTANT_PROMPTS = {
  fr: [
    "Qu'est-ce qui est urgent aujourd'hui ?",
    "Quels clients dois-je relancer ?",
    "Résume-moi ma journée",
    "Analyse mon pipeline CRM",
  ],
  en: [
    "What's urgent today?",
    "Which clients should I follow up?",
    "Summarize my day",
    "Analyze my CRM pipeline",
  ],
};

// Contexte transmis à l'IA (démo) pour des réponses concrètes.
export const ASSISTANT_CONTEXT = {
  fr: "Feuilles de temps à approuver: 3. Soumissions à relancer: 2. Facture en retard: 1 (montant 3 200 $). Tâches chantier ouvertes: 4. Clients sans suivi depuis 7 jours: 2. Ticket support urgent: 1. Pipeline CRM: 48 500 $. Factures à recevoir: 12 400 $. Heures cette semaine: 386 h. Projets actifs: 4. Employés actifs: 14.",
  en: "Timesheets to approve: 3. Quotes to follow up: 2. Overdue invoice: 1 ($3,200). Open job-site tasks: 4. Clients with no follow-up in 7 days: 2. Urgent support ticket: 1. CRM pipeline: $48,500. Receivables: $12,400. Hours this week: 386 h. Active projects: 4. Active employees: 14.",
};
